import { CreateFoodStockDTO } from '../models/FoodStock'
import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function CreateFoodStockCase(foodStockRepository: FoodStockRepository) {
  return async function (data: CreateFoodStockDTO) {
    return await foodStockRepository.createFoodStock(data)
  }
}
